module.exports = __webpack_public_path__ + "static/media/finanziamenti-bg.fba0225a.jpg";